const PIXEL_ID = '1462943505418119'

declare global {
  interface Window {
    fbq: any
    _fbq: any
  }
}

let initialized = false

export function initMetaPixel() {
  if (initialized || typeof window === 'undefined') return

  // Manual fbq initialization (safe for sandboxed environments)
  const n: any = (window.fbq = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
  })
  if (!window._fbq) window._fbq = n
  n.push = n
  n.loaded = true
  n.version = '2.0'
  n.queue = []

  // Load the Facebook pixel script safely
  try {
    const t = document.createElement('script')
    t.async = true
    t.src = 'https://connect.facebook.net/en_US/fbevents.js'
    const s = document.getElementsByTagName('head')[0]
    if (s) {
      s.appendChild(t)
    } else {
      document.documentElement.appendChild(t)
    }
  } catch (e) {
    console.warn('Meta Pixel script could not be loaded:', e)
  }

  window.fbq('init', PIXEL_ID)
  initialized = true
}

export function trackPageView() {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', 'PageView')
  }
}

export function trackAddToCart() {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', 'AddToCart', {
      content_name: 'Shopify Express 48H',
      content_type: 'product',
      value: 6.39,
      currency: 'USD',
    })
  }
}
